import { createContext, useRef, useState } from "react";

export interface PickGuard {
    markPick: () => void;
    /** True if a Reuse pick happened after the render that read this guard. */
    pickedSince: () => boolean;
}

export const PickGuardContext = createContext<PickGuard | null>(null);

/** A Reuse pick wins over an upload into the same slot that started before it:
 *  UploadFile finishes with the handler from drop time, which checks this. */
export function usePickGuard(): PickGuard {
    const [picks, setPicks] = useState(0);
    const latest = useRef(0);
    return {
        markPick: () => {
            latest.current += 1;
            setPicks(latest.current);
        },
        pickedSince: () => latest.current !== picks,
    };
}
